/* Bundled city list for the "search by place name" location pickers
   (HomePage + MuhurtamChecker). Deliberately NOT a live geocoding API call —
   this app avoids external API dependencies everywhere (chatbot, weather,
   location), so this is a curated, offline list instead. It covers Indian
   state capitals/major cities (the app's primary audience) plus a handful
   of major world cities for diaspora users, rather than exhaustive global
   coverage. tzOffsetMin is each place's standard-time UTC offset in minutes
   (no daylight-saving adjustment, consistent with how the rest of the app
   already treats timezone as a plain manual offset) — editable afterward
   like any other field once a city is picked.

   Add more entries here as needed; each is independent, so this list can
   grow safely over time. */

export const CITIES = [
  // --- Telangana / Andhra Pradesh (primary audience) ---
  { name: "Hyderabad, Telangana, India", lat: 17.3850, lon: 78.4867, tzOffsetMin: 330 },
  { name: "Warangal, Telangana, India", lat: 17.9689, lon: 79.5941, tzOffsetMin: 330 },
  { name: "Karimnagar, Telangana, India", lat: 18.4386, lon: 79.1288, tzOffsetMin: 330 },
  { name: "Nizamabad, Telangana, India", lat: 18.6725, lon: 78.0941, tzOffsetMin: 330 },
  { name: "Vijayawada, Andhra Pradesh, India", lat: 16.5062, lon: 80.6480, tzOffsetMin: 330 },
  { name: "Visakhapatnam, Andhra Pradesh, India", lat: 17.6868, lon: 83.2185, tzOffsetMin: 330 },
  { name: "Amaravati, Andhra Pradesh, India", lat: 16.5130, lon: 80.5150, tzOffsetMin: 330 },
  { name: "Tirupati, Andhra Pradesh, India", lat: 13.6288, lon: 79.4192, tzOffsetMin: 330 },
  { name: "Guntur, Andhra Pradesh, India", lat: 16.3067, lon: 80.4365, tzOffsetMin: 330 },
  { name: "Nellore, Andhra Pradesh, India", lat: 14.4426, lon: 79.9865, tzOffsetMin: 330 },
  { name: "Kurnool, Andhra Pradesh, India", lat: 15.8281, lon: 78.0373, tzOffsetMin: 330 },
  { name: "Rajahmundry, Andhra Pradesh, India", lat: 17.0005, lon: 81.8040, tzOffsetMin: 330 },

  // --- Other major Indian cities / state capitals ---
  { name: "New Delhi, Delhi, India", lat: 28.6139, lon: 77.2090, tzOffsetMin: 330 },
  { name: "Mumbai, Maharashtra, India", lat: 19.0760, lon: 72.8777, tzOffsetMin: 330 },
  { name: "Pune, Maharashtra, India", lat: 18.5204, lon: 73.8567, tzOffsetMin: 330 },
  { name: "Nagpur, Maharashtra, India", lat: 21.1458, lon: 79.0882, tzOffsetMin: 330 },
  { name: "Bengaluru, Karnataka, India", lat: 12.9716, lon: 77.5946, tzOffsetMin: 330 },
  { name: "Mysuru, Karnataka, India", lat: 12.2958, lon: 76.6394, tzOffsetMin: 330 },
  { name: "Chennai, Tamil Nadu, India", lat: 13.0827, lon: 80.2707, tzOffsetMin: 330 },
  { name: "Coimbatore, Tamil Nadu, India", lat: 11.0168, lon: 76.9558, tzOffsetMin: 330 },
  { name: "Madurai, Tamil Nadu, India", lat: 9.9252, lon: 78.1198, tzOffsetMin: 330 },
  { name: "Thiruvananthapuram, Kerala, India", lat: 8.5241, lon: 76.9366, tzOffsetMin: 330 },
  { name: "Kochi, Kerala, India", lat: 9.9312, lon: 76.2673, tzOffsetMin: 330 },
  { name: "Kolkata, West Bengal, India", lat: 22.5726, lon: 88.3639, tzOffsetMin: 330 },
  { name: "Bhubaneswar, Odisha, India", lat: 20.2961, lon: 85.8245, tzOffsetMin: 330 },
  { name: "Ahmedabad, Gujarat, India", lat: 23.0225, lon: 72.5714, tzOffsetMin: 330 },
  { name: "Gandhinagar, Gujarat, India", lat: 23.2156, lon: 72.6369, tzOffsetMin: 330 },
  { name: "Surat, Gujarat, India", lat: 21.1702, lon: 72.8311, tzOffsetMin: 330 },
  { name: "Jaipur, Rajasthan, India", lat: 26.9124, lon: 75.7873, tzOffsetMin: 330 },
  { name: "Lucknow, Uttar Pradesh, India", lat: 26.8467, lon: 80.9462, tzOffsetMin: 330 },
  { name: "Kanpur, Uttar Pradesh, India", lat: 26.4499, lon: 80.3319, tzOffsetMin: 330 },
  { name: "Varanasi, Uttar Pradesh, India", lat: 25.3176, lon: 82.9739, tzOffsetMin: 330 },
  { name: "Patna, Bihar, India", lat: 25.5941, lon: 85.1376, tzOffsetMin: 330 },
  { name: "Bhopal, Madhya Pradesh, India", lat: 23.2599, lon: 77.4126, tzOffsetMin: 330 },
  { name: "Indore, Madhya Pradesh, India", lat: 22.7196, lon: 75.8577, tzOffsetMin: 330 },
  { name: "Chandigarh, India", lat: 30.7333, lon: 76.7794, tzOffsetMin: 330 },
  { name: "Amritsar, Punjab, India", lat: 31.6340, lon: 74.8723, tzOffsetMin: 330 },
  { name: "Dehradun, Uttarakhand, India", lat: 30.3165, lon: 78.0322, tzOffsetMin: 330 },
  { name: "Shimla, Himachal Pradesh, India", lat: 31.1048, lon: 77.1734, tzOffsetMin: 330 },
  { name: "Srinagar, Jammu & Kashmir, India", lat: 34.0837, lon: 74.7973, tzOffsetMin: 330 },
  { name: "Panaji, Goa, India", lat: 15.4909, lon: 73.8278, tzOffsetMin: 330 },
  { name: "Guwahati, Assam, India", lat: 26.1445, lon: 91.7362, tzOffsetMin: 330 },
  { name: "Ranchi, Jharkhand, India", lat: 23.3441, lon: 85.3096, tzOffsetMin: 330 },
  { name: "Raipur, Chhattisgarh, India", lat: 21.2514, lon: 81.6296, tzOffsetMin: 330 },

  // --- More Indian cities / district headquarters / temple towns ---
  { name: "Karimnagar, Telangana, India", lat: 18.4386, lon: 79.1288, tzOffsetMin: 330 },
  { name: "Khammam, Telangana, India", lat: 17.2473, lon: 80.1514, tzOffsetMin: 330 },
  { name: "Mahbubnagar, Telangana, India", lat: 16.7488, lon: 77.9857, tzOffsetMin: 330 },
  { name: "Adilabad, Telangana, India", lat: 19.6641, lon: 78.5320, tzOffsetMin: 330 },
  { name: "Siddipet, Telangana, India", lat: 18.1018, lon: 78.8524, tzOffsetMin: 330 },
  { name: "Nalgonda, Telangana, India", lat: 17.0575, lon: 79.2690, tzOffsetMin: 330 },
  { name: "Kakinada, Andhra Pradesh, India", lat: 16.9891, lon: 82.2475, tzOffsetMin: 330 },
  { name: "Eluru, Andhra Pradesh, India", lat: 16.7107, lon: 81.0952, tzOffsetMin: 330 },
  { name: "Ongole, Andhra Pradesh, India", lat: 15.5057, lon: 80.0499, tzOffsetMin: 330 },
  { name: "Anantapur, Andhra Pradesh, India", lat: 14.6819, lon: 77.6006, tzOffsetMin: 330 },
  { name: "Chittoor, Andhra Pradesh, India", lat: 13.2172, lon: 79.1003, tzOffsetMin: 330 },
  { name: "Srikakulam, Andhra Pradesh, India", lat: 18.2949, lon: 83.8938, tzOffsetMin: 330 },
  { name: "Vizianagaram, Andhra Pradesh, India", lat: 18.1067, lon: 83.3956, tzOffsetMin: 330 },
  { name: "Machilipatnam, Andhra Pradesh, India", lat: 16.1875, lon: 81.1389, tzOffsetMin: 330 },
  { name: "Srisailam, Andhra Pradesh, India", lat: 16.0739, lon: 78.8686, tzOffsetMin: 330 },
  { name: "Trichy (Tiruchirappalli), Tamil Nadu, India", lat: 10.7905, lon: 78.7047, tzOffsetMin: 330 },
  { name: "Salem, Tamil Nadu, India", lat: 11.6643, lon: 78.1460, tzOffsetMin: 330 },
  { name: "Tirunelveli, Tamil Nadu, India", lat: 8.7139, lon: 77.7567, tzOffsetMin: 330 },
  { name: "Vellore, Tamil Nadu, India", lat: 12.9165, lon: 79.1325, tzOffsetMin: 330 },
  { name: "Erode, Tamil Nadu, India", lat: 11.3410, lon: 77.7172, tzOffsetMin: 330 },
  { name: "Thanjavur, Tamil Nadu, India", lat: 10.7870, lon: 79.1378, tzOffsetMin: 330 },
  { name: "Rameswaram, Tamil Nadu, India", lat: 9.2876, lon: 79.3129, tzOffsetMin: 330 },
  { name: "Kanyakumari, Tamil Nadu, India", lat: 8.0883, lon: 77.5385, tzOffsetMin: 330 },
  { name: "Mysuru District, Karnataka, India", lat: 12.2958, lon: 76.6394, tzOffsetMin: 330 },
  { name: "Hubballi-Dharwad, Karnataka, India", lat: 15.3647, lon: 75.1240, tzOffsetMin: 330 },
  { name: "Mangaluru, Karnataka, India", lat: 12.9141, lon: 74.8560, tzOffsetMin: 330 },
  { name: "Belagavi, Karnataka, India", lat: 15.8497, lon: 74.4977, tzOffsetMin: 330 },
  { name: "Shivamogga, Karnataka, India", lat: 13.9299, lon: 75.5681, tzOffsetMin: 330 },
  { name: "Tumakuru, Karnataka, India", lat: 13.3379, lon: 77.1173, tzOffsetMin: 330 },
  { name: "Udupi, Karnataka, India", lat: 13.3409, lon: 74.7421, tzOffsetMin: 330 },
  { name: "Kochi (Ernakulam), Kerala, India", lat: 9.9312, lon: 76.2673, tzOffsetMin: 330 },
  { name: "Kozhikode, Kerala, India", lat: 11.2588, lon: 75.7804, tzOffsetMin: 330 },
  { name: "Thrissur, Kerala, India", lat: 10.5276, lon: 76.2144, tzOffsetMin: 330 },
  { name: "Kollam, Kerala, India", lat: 8.8932, lon: 76.6141, tzOffsetMin: 330 },
  { name: "Alappuzha, Kerala, India", lat: 9.4981, lon: 76.3388, tzOffsetMin: 330 },
  { name: "Guruvayur, Kerala, India", lat: 10.5944, lon: 76.0417, tzOffsetMin: 330 },
  { name: "Sabarimala, Kerala, India", lat: 9.4351, lon: 77.0827, tzOffsetMin: 330 },
  { name: "Nashik, Maharashtra, India", lat: 19.9975, lon: 73.7898, tzOffsetMin: 330 },
  { name: "Aurangabad, Maharashtra, India", lat: 19.8762, lon: 75.3433, tzOffsetMin: 330 },
  { name: "Kolhapur, Maharashtra, India", lat: 16.7050, lon: 74.2433, tzOffsetMin: 330 },
  { name: "Solapur, Maharashtra, India", lat: 17.6599, lon: 75.9064, tzOffsetMin: 330 },
  { name: "Thane, Maharashtra, India", lat: 19.2183, lon: 72.9781, tzOffsetMin: 330 },
  { name: "Shirdi, Maharashtra, India", lat: 19.7645, lon: 74.4769, tzOffsetMin: 330 },
  { name: "Rajkot, Gujarat, India", lat: 22.3039, lon: 70.8022, tzOffsetMin: 330 },
  { name: "Vadodara, Gujarat, India", lat: 22.3072, lon: 73.1812, tzOffsetMin: 330 },
  { name: "Bhavnagar, Gujarat, India", lat: 21.7645, lon: 72.1519, tzOffsetMin: 330 },
  { name: "Dwarka, Gujarat, India", lat: 22.2394, lon: 68.9678, tzOffsetMin: 330 },
  { name: "Somnath, Gujarat, India", lat: 20.8880, lon: 70.4012, tzOffsetMin: 330 },
  { name: "Agra, Uttar Pradesh, India", lat: 27.1767, lon: 78.0081, tzOffsetMin: 330 },
  { name: "Prayagraj (Allahabad), Uttar Pradesh, India", lat: 25.4358, lon: 81.8463, tzOffsetMin: 330 },
  { name: "Mathura, Uttar Pradesh, India", lat: 27.4924, lon: 77.6737, tzOffsetMin: 330 },
  { name: "Ayodhya, Uttar Pradesh, India", lat: 26.7922, lon: 82.1998, tzOffsetMin: 330 },
  { name: "Gorakhpur, Uttar Pradesh, India", lat: 26.7606, lon: 83.3732, tzOffsetMin: 330 },
  { name: "Meerut, Uttar Pradesh, India", lat: 28.9845, lon: 77.7064, tzOffsetMin: 330 },
  { name: "Noida, Uttar Pradesh, India", lat: 28.5355, lon: 77.3910, tzOffsetMin: 330 },
  { name: "Ghaziabad, Uttar Pradesh, India", lat: 28.6692, lon: 77.4538, tzOffsetMin: 330 },
  { name: "Jabalpur, Madhya Pradesh, India", lat: 23.1815, lon: 79.9864, tzOffsetMin: 330 },
  { name: "Gwalior, Madhya Pradesh, India", lat: 26.2183, lon: 78.1828, tzOffsetMin: 330 },
  { name: "Ujjain, Madhya Pradesh, India", lat: 23.1765, lon: 75.7885, tzOffsetMin: 330 },
  { name: "Nagpur District, Maharashtra, India", lat: 21.1458, lon: 79.0882, tzOffsetMin: 330 },
  { name: "Udaipur, Rajasthan, India", lat: 24.5854, lon: 73.7125, tzOffsetMin: 330 },
  { name: "Jodhpur, Rajasthan, India", lat: 26.2389, lon: 73.0243, tzOffsetMin: 330 },
  { name: "Ajmer, Rajasthan, India", lat: 26.4499, lon: 74.6399, tzOffsetMin: 330 },
  { name: "Kota, Rajasthan, India", lat: 25.2138, lon: 75.8648, tzOffsetMin: 330 },
  { name: "Pushkar, Rajasthan, India", lat: 26.4899, lon: 74.5511, tzOffsetMin: 330 },
  { name: "Bikaner, Rajasthan, India", lat: 28.0229, lon: 73.3119, tzOffsetMin: 330 },
  { name: "Haridwar, Uttarakhand, India", lat: 29.9457, lon: 78.1642, tzOffsetMin: 330 },
  { name: "Rishikesh, Uttarakhand, India", lat: 30.0869, lon: 78.2676, tzOffsetMin: 330 },
  { name: "Nainital, Uttarakhand, India", lat: 29.3919, lon: 79.4542, tzOffsetMin: 330 },
  { name: "Kedarnath, Uttarakhand, India", lat: 30.7346, lon: 79.0669, tzOffsetMin: 330 },
  { name: "Badrinath, Uttarakhand, India", lat: 30.7433, lon: 79.4938, tzOffsetMin: 330 },
  { name: "Manali, Himachal Pradesh, India", lat: 32.2432, lon: 77.1892, tzOffsetMin: 330 },
  { name: "Dharamshala, Himachal Pradesh, India", lat: 32.2190, lon: 76.3234, tzOffsetMin: 330 },
  { name: "Jalandhar, Punjab, India", lat: 31.3260, lon: 75.5762, tzOffsetMin: 330 },
  { name: "Ludhiana, Punjab, India", lat: 30.9010, lon: 75.8573, tzOffsetMin: 330 },
  { name: "Patiala, Punjab, India", lat: 30.3398, lon: 76.3869, tzOffsetMin: 330 },
  { name: "Faridabad, Haryana, India", lat: 28.4089, lon: 77.3178, tzOffsetMin: 330 },
  { name: "Gurugram, Haryana, India", lat: 28.4595, lon: 77.0266, tzOffsetMin: 330 },
  { name: "Kurukshetra, Haryana, India", lat: 29.9695, lon: 76.8783, tzOffsetMin: 330 },
  { name: "Howrah, West Bengal, India", lat: 22.5958, lon: 88.2636, tzOffsetMin: 330 },
  { name: "Siliguri, West Bengal, India", lat: 26.7271, lon: 88.3953, tzOffsetMin: 330 },
  { name: "Durgapur, West Bengal, India", lat: 23.5204, lon: 87.3119, tzOffsetMin: 330 },
  { name: "Puri, Odisha, India", lat: 19.8135, lon: 85.8312, tzOffsetMin: 330 },
  { name: "Cuttack, Odisha, India", lat: 20.4625, lon: 85.8828, tzOffsetMin: 330 },
  { name: "Jamshedpur, Jharkhand, India", lat: 22.8046, lon: 86.2029, tzOffsetMin: 330 },
  { name: "Dhanbad, Jharkhand, India", lat: 23.7957, lon: 86.4304, tzOffsetMin: 330 },
  { name: "Bilaspur, Chhattisgarh, India", lat: 22.0797, lon: 82.1409, tzOffsetMin: 330 },
  { name: "Jammu, Jammu & Kashmir, India", lat: 32.7266, lon: 74.8570, tzOffsetMin: 330 },
  { name: "Vaishno Devi (Katra), Jammu & Kashmir, India", lat: 33.0300, lon: 74.9494, tzOffsetMin: 330 },
  { name: "Leh, Ladakh, India", lat: 34.1526, lon: 77.5771, tzOffsetMin: 330 },
  { name: "Margao, Goa, India", lat: 15.2832, lon: 73.9862, tzOffsetMin: 330 },
  { name: "Dispur, Assam, India", lat: 26.1433, lon: 91.7898, tzOffsetMin: 330 },
  { name: "Silchar, Assam, India", lat: 24.8333, lon: 92.7789, tzOffsetMin: 330 },
  { name: "Shillong, Meghalaya, India", lat: 25.5788, lon: 91.8933, tzOffsetMin: 330 },
  { name: "Imphal, Manipur, India", lat: 24.8170, lon: 93.9368, tzOffsetMin: 330 },
  { name: "Aizawl, Mizoram, India", lat: 23.7271, lon: 92.7176, tzOffsetMin: 330 },
  { name: "Kohima, Nagaland, India", lat: 25.6751, lon: 94.1086, tzOffsetMin: 330 },
  { name: "Agartala, Tripura, India", lat: 23.8315, lon: 91.2868, tzOffsetMin: 330 },
  { name: "Itanagar, Arunachal Pradesh, India", lat: 27.0844, lon: 93.6053, tzOffsetMin: 330 },
  { name: "Gangtok, Sikkim, India", lat: 27.3389, lon: 88.6065, tzOffsetMin: 330 },

  // --- Major world cities (diaspora) ---
  { name: "London, United Kingdom", lat: 51.5074, lon: -0.1278, tzOffsetMin: 0 },
  { name: "New York, USA", lat: 40.7128, lon: -74.0060, tzOffsetMin: -300 },
  { name: "San Francisco, USA", lat: 37.7749, lon: -122.4194, tzOffsetMin: -480 },
  { name: "Toronto, Canada", lat: 43.6532, lon: -79.3832, tzOffsetMin: -300 },
  { name: "Dubai, UAE", lat: 25.2048, lon: 55.2708, tzOffsetMin: 240 },
  { name: "Muscat, Oman", lat: 23.5880, lon: 58.3829, tzOffsetMin: 240 },
  { name: "Riyadh, Saudi Arabia", lat: 24.7136, lon: 46.6753, tzOffsetMin: 180 },
  { name: "Singapore", lat: 1.3521, lon: 103.8198, tzOffsetMin: 480 },
  { name: "Kuala Lumpur, Malaysia", lat: 3.1390, lon: 101.6869, tzOffsetMin: 480 },
  { name: "Sydney, Australia", lat: -33.8688, lon: 151.2093, tzOffsetMin: 600 },
  { name: "Melbourne, Australia", lat: -37.8136, lon: 144.9631, tzOffsetMin: 600 },
  { name: "Perth, Australia", lat: -31.9505, lon: 115.8605, tzOffsetMin: 480 },
  { name: "Auckland, New Zealand", lat: -36.8485, lon: 174.7633, tzOffsetMin: 780 },
  { name: "Los Angeles, USA", lat: 34.0522, lon: -118.2437, tzOffsetMin: -480 },
  { name: "Chicago, USA", lat: 41.8781, lon: -87.6298, tzOffsetMin: -360 },
  { name: "Houston, USA", lat: 29.7604, lon: -95.3698, tzOffsetMin: -360 },
  { name: "Dallas, USA", lat: 32.7767, lon: -96.7970, tzOffsetMin: -360 },
  { name: "Seattle, USA", lat: 47.6062, lon: -122.3321, tzOffsetMin: -480 },
  { name: "Boston, USA", lat: 42.3601, lon: -71.0589, tzOffsetMin: -300 },
  { name: "Washington DC, USA", lat: 38.9072, lon: -77.0369, tzOffsetMin: -300 },
  { name: "Atlanta, USA", lat: 33.7490, lon: -84.3880, tzOffsetMin: -300 },
  { name: "New Jersey, USA", lat: 40.0583, lon: -74.4057, tzOffsetMin: -300 },
  { name: "Vancouver, Canada", lat: 49.2827, lon: -123.1207, tzOffsetMin: -480 },
  { name: "Ottawa, Canada", lat: 45.4215, lon: -75.6972, tzOffsetMin: -300 },
  { name: "Manchester, United Kingdom", lat: 53.4808, lon: -2.2426, tzOffsetMin: 0 },
  { name: "Birmingham, United Kingdom", lat: 52.4862, lon: -1.8904, tzOffsetMin: 0 },
  { name: "Leicester, United Kingdom", lat: 52.6369, lon: -1.1398, tzOffsetMin: 0 },
  { name: "Paris, France", lat: 48.8566, lon: 2.3522, tzOffsetMin: 60 },
  { name: "Berlin, Germany", lat: 52.5200, lon: 13.4050, tzOffsetMin: 60 },
  { name: "Frankfurt, Germany", lat: 50.1109, lon: 8.6821, tzOffsetMin: 60 },
  { name: "Amsterdam, Netherlands", lat: 52.3676, lon: 4.9041, tzOffsetMin: 60 },
  { name: "Zurich, Switzerland", lat: 47.3769, lon: 8.5417, tzOffsetMin: 60 },
  { name: "Rome, Italy", lat: 41.9028, lon: 12.4964, tzOffsetMin: 60 },
  { name: "Dublin, Ireland", lat: 53.3498, lon: -6.2603, tzOffsetMin: 0 },
  { name: "Stockholm, Sweden", lat: 59.3293, lon: 18.0686, tzOffsetMin: 60 },
  { name: "Abu Dhabi, UAE", lat: 24.4539, lon: 54.3773, tzOffsetMin: 240 },
  { name: "Sharjah, UAE", lat: 25.3463, lon: 55.4209, tzOffsetMin: 240 },
  { name: "Doha, Qatar", lat: 25.2854, lon: 51.5310, tzOffsetMin: 180 },
  { name: "Kuwait City, Kuwait", lat: 29.3759, lon: 47.9774, tzOffsetMin: 180 },
  { name: "Manama, Bahrain", lat: 26.2285, lon: 50.5860, tzOffsetMin: 180 },
  { name: "Jeddah, Saudi Arabia", lat: 21.5433, lon: 39.1728, tzOffsetMin: 180 },
  { name: "Dammam, Saudi Arabia", lat: 26.4207, lon: 50.0888, tzOffsetMin: 180 },
  { name: "Tokyo, Japan", lat: 35.6762, lon: 139.6503, tzOffsetMin: 540 },
  { name: "Hong Kong", lat: 22.3193, lon: 114.1694, tzOffsetMin: 480 },
  { name: "Shanghai, China", lat: 31.2304, lon: 121.4737, tzOffsetMin: 480 },
  { name: "Bangkok, Thailand", lat: 13.7563, lon: 100.5018, tzOffsetMin: 420 },
  { name: "Jakarta, Indonesia", lat: -6.2088, lon: 106.8456, tzOffsetMin: 420 },
  { name: "Manila, Philippines", lat: 14.5995, lon: 120.9842, tzOffsetMin: 480 },
  { name: "Seoul, South Korea", lat: 37.5665, lon: 126.9780, tzOffsetMin: 540 },
  { name: "Colombo, Sri Lanka", lat: 6.9271, lon: 79.8612, tzOffsetMin: 330 },
  { name: "Kathmandu, Nepal", lat: 27.7172, lon: 85.3240, tzOffsetMin: 345 },
  { name: "Dhaka, Bangladesh", lat: 23.8103, lon: 90.4125, tzOffsetMin: 360 },
  { name: "Karachi, Pakistan", lat: 24.8607, lon: 67.0011, tzOffsetMin: 300 },
  { name: "Lahore, Pakistan", lat: 31.5497, lon: 74.3436, tzOffsetMin: 300 },
  { name: "Mauritius (Port Louis)", lat: -20.1609, lon: 57.5012, tzOffsetMin: 240 },
  { name: "Johannesburg, South Africa", lat: -26.2041, lon: 28.0473, tzOffsetMin: 120 },
  { name: "Durban, South Africa", lat: -29.8587, lon: 31.0218, tzOffsetMin: 120 },
  { name: "Nairobi, Kenya", lat: -1.2921, lon: 36.8219, tzOffsetMin: 180 },
  { name: "Fiji (Suva)", lat: -18.1416, lon: 178.4419, tzOffsetMin: 720 },
  { name: "Trinidad (Port of Spain)", lat: 10.6549, lon: -61.5019, tzOffsetMin: -240 },
];

// Haversine distance in km, used to find the nearest bundled city to an
// arbitrary lat/lon (GPS location or manually-typed coordinates) so we can
// show an approximate place name even when it wasn't picked from the list.
function distanceKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

// Returns { name, distanceKm } for the closest bundled city, or null if the
// list is somehow empty. Distance is included so callers can decide whether
// "near X" is honest (e.g. only label it if within ~50km).
export function findNearestCity(lat, lon) {
  let best = null;
  let bestDist = Infinity;
  for (const c of CITIES) {
    const d = distanceKm(lat, lon, c.lat, c.lon);
    if (d < bestDist) {
      bestDist = d;
      best = c;
    }
  }
  return best ? { name: best.name, distanceKm: bestDist } : null;
}
